export const REFRESHER_KIT_REQUEST_URL = '/refresher-kits'
export const REFRESHER_KIT_LOGIN_SOURCE = 'Refresher Kit Request Page'
export const CATALOG_PAGE_SIZE = 50

export const INVITATION_STATUSES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  USED: 'used',
  DEACTIVATED: 'deactivated',
} as const

export const CATALOG_PHOTO_SOURCES = {
  PREVIEW_KEY: 'previewKey',
  SIGNED_URL: 'signedUrl',
} as const

export const REQUEST_STEPS = {
  SELECT: 'select',
  SUMMARY: 'summary',
  SHIPPING: 'shipping',
} as const

export type RequestStep = (typeof REQUEST_STEPS)[keyof typeof REQUEST_STEPS]
